// frontend/src/services/apiConfig.ts
import axios from 'axios';
import { useAuthStore } from '.././stores/authStore';

// 1. Determina a URL base da API
// Em produção (no Docker), o frontend e o backend rodam na mesma origem e porta.
// Por isso podemos usar apenas '/api' em vez de forçar a porta 3003.
const isDevelopment = process.env.NODE_ENV === 'development';
export const backendHost = process.env.REACT_APP_API_URL || (isDevelopment ? `http://${window.location.hostname}:3003` : '');

// 2. Cria e configura a instância do Axios aqui
const api = axios.create({
    baseURL: backendHost ? `${backendHost}/api` : '/api'
});

// 3. Interceptor de REQUISIÇÃO (Já existente)
// Adiciona o token em todas as chamadas
api.interceptors.request.use(
    (config) => {
        const { token } = useAuthStore.getState();

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

//  Interceptor de RESPOSTA
// Lida com erros globais, especialmente o 401
api.interceptors.response.use(
    (response) => {
        // Se a resposta for sucesso, apenas a retorna
        return response;
    },
    (error) => {
        // Verifica se o erro é uma resposta da API e se o status é 401
        if (error.response && error.response.status === 401) {
            // Token é inválido ou expirou

            // 1. Chama a ação de logout do zustand
            // Isso irá atualizar isAuthenticated para false e limpar os dados
            useAuthStore.getState().logout();

            // 2. Redireciona o usuário para a tela de login
            // Usamos window.location.href para forçar um refresh completo,
            // garantindo que todo o estado do React seja limpo.
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        // Retorna o erro para que o 'catch' da chamada original (ex: no componente)
        // ainda possa tratá-lo, se necessário.
        return Promise.reject(error);
    }
);


// 5. Exporta a instância 'api' como padrão
export default api;